export const accountBasePath = '/account';
export const googleMapsKey = window.googleMapAPIKey
	? window.googleMapAPIKey
	: 'AIzaSyAE1I7ODPm1d1d1Q769J9HJaSGhJcnvkkA';
export const googleRecaptchaKey = window.googleReCaptchaSiteKey
	? window.googleReCaptchaSiteKey
	: '6LdoaFMUAAAAAD1l4E2Q_NfAyNnDRVZmLp7xr_-p';
export const assetsDirectory = window.cmsAssetsFolder
	? window.cmsAssetsFolder
	: '/assets/';
